import { ILesson, IModule, ISelectValue } from '@/@types'
import { DataTableFacetedFilter } from '@/components/data-table/faceted-filter'
import { Table } from '@tanstack/react-table'

interface Props {
  table?: Table<ILesson>
  modules?: IModule[]
}

export function TableToolbar({ table, modules }: Props) {
  const MODULES: ISelectValue[] = [
    ...new Set(modules?.map(({ name }) => ({ label: name, value: name }))),
  ]

  const LEVELS: ISelectValue[] = [
    { label: 'Nível 1', value: 'level 1' },
    { label: 'Nível 2', value: 'level 2' },
    { label: 'Nível 3', value: 'level 3' },
    { label: 'Nível 4', value: 'level 4' },
    { label: 'Nível 5', value: 'level 5' },
  ]

  if (!table) return null

  return (
    <>
      {MODULES && (
        <DataTableFacetedFilter
          title="Módulo"
          table={table}
          columnId="module.name"
          options={MODULES}
        />
      )}

      {LEVELS && (
        <DataTableFacetedFilter
          title="Nível"
          table={table}
          columnId="level"
          options={LEVELS}
        />
      )}
    </>
  )
}
